import SignUp from "./components/SignUp.svelte";

const signup = new SignUp({
	target: document.querySelector(".signup-container"),
});

export default signup;
